var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Star 11",
    d: "M17.1467 0.954159C17.5576 -0.31042 19.3466 -0.310424 19.7575 0.954154L23.0746 11.163C23.2583 11.7286 23.7854 12.1115 24.38 12.1115H35.1142C36.4439 12.1115 36.9968 13.813 35.921 14.5945L27.2368 20.9039C26.7558 21.2535 26.5545 21.873 26.7382 22.4385L30.0553 32.6474C30.4662 33.912 29.0188 34.9636 27.9431 34.182L19.2589 27.8726C18.7778 27.5231 18.1264 27.5231 17.6453 27.8726L8.96114 34.182C7.88542 34.9636 6.43805 33.912 6.84894 32.6474L10.166 22.4385C10.3498 21.873 10.1485 21.2535 9.66739 20.9039L0.983194 14.5945C-0.0925205 13.813 0.460321 12.1115 1.78998 12.1115H12.5242C13.1189 12.1115 13.6459 11.7286 13.8296 11.163L17.1467 0.954159Z",
    fill: "#E8E8E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.f64e4f32cb42421dfd8c689dd2238a99.svg";
export { ForwardRef as ReactComponent };